<template>
  <section class="section">
    <div class="container">
      <!-- <h1 class="title">Дневна паркинг карта</h1> -->
      <h1 class="title">Куповина дневне паркинг карте</h1>
      <b-steps>
        <b-step-item label="E-дневна паркинг карта" icon="account-key">
          <DnevnaParkingKartaForma />
        </b-step-item>
        <b-step-item label="Корпа" icon="account">
          <Korpa />
        </b-step-item>
        <b-step-item label="Провера" icon="account-plus">
          <Provera />
        </b-step-item>
      </b-steps>
    </div>
  </section>
</template>

<script>
import DnevnaParkingKartaForma from '../components/DnevnaParkingKartaForma'
import Korpa from '../components/Korpa'
import Provera from '../components/Provera'

export default {
  components: {
    DnevnaParkingKartaForma,
    Korpa,
    Provera
  }
}
</script>

<style></style>
